import {
  Box,
  Button,
  Center,
  Heading,
  Image,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { MCDConfirmation } from '../../assets';

export const Confirmation = () => (
  <Center>
    <Stack>
      <Box pb={8}>
        <Image src={MCDConfirmation} alt="mcd-confirmation" w="full" />
        <VStack spacing={4}>
          <Heading color="brand.primary.swatch1" fontSize="24px">
            Donation Received
          </Heading>
          <Text fontSize="md">
            Thank you for submitting your donation through our mobile check
            deposit tool. Every dollar helps the kids of St. Jude.
          </Text>
        </VStack>
      </Box>
      <Stack spacing={4}>
        <Button
          colorScheme="blue"
          to="/check-deposit"
          as={Link}
          textDecoration="none"
          color="white"
        >
          Deposit another check
        </Button>
        <Button
          colorScheme="blue"
          variant="secondary"
          as={Link}
          to="/dashboard"
          textDecoration="none"
        >
          Return to fundraising center
        </Button>
      </Stack>
    </Stack>
  </Center>
);
